import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { mapStateToProps } from 'explore/containers/projects_controls';
import Controls from 'your_projects/components/controls';

export default withRouter(connect(mapStateToProps)(Controls));
